import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useHistory } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";

const Search = ({ data }) => {
  const history = useHistory(); //habilitar history para redirecciones
  const onClick = (id) => {
    if (data[0].trait != null) {
      history.push(`enemy-detail/${id}`);
    } else {
      history.push(`char-detail/${id}`);
    }
  };
  return (
    <Autocomplete
      id="country-select-demo"
      options={data}
      autoHighlight
      getOptionLabel={(option) => option.name}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
          {...props}
          onClick={() => onClick(option._id)}
        >
          <img loading="lazy" width="40" src={option.image} alt="" />
          {option.name}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="SEARCH"
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password", // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
};

export default Search;
